export default "__VITE_ASSET__8b70b0e1__"